








import { Component, Vue } from "vue-property-decorator";

const events = {
  buy: Symbol("buy"),
  transaction: Symbol("transaction"),
  order: Symbol("order")
};

@Component
class Actions extends Vue {
  get actions() {
    return [
      {
        text: this.$t("common.request-buy"),
        icon: "$vuetify.icons.iconPlus",
        color: "#008DDC",
        size: "16",
        event: events.buy
      },
      {
        text: this.$t("common.transactions"),
        icon: "$vuetify.icons.iconSwitch",
        color: "#F5A623",
        size: "16",
        event: events.transaction
      },
      {
        text: this.$t("common.order"),
        icon: "$vuetify.icons.iconOrder",
        color: "#008DDC",
        size: "16",
        event: events.order
      }
    ];
  }

  handleActionClick(action) {
    switch (action.event) {
      case events.buy:
        this.handleBuy();
        break;
      case events.transaction:
        this.handleToTransaction();
        break;
      case events.order:
        this.handleToOrder();
        break;
    }
  }

  handleBuy() {
    this.$helper.toFusionPath(this, "defi", {
      name: "index"
    });
  }

  handleToTransaction() {
    this.$helper.toFusionPath(this, "defi", {
      name: "transactions"
    });
  }

  handleToOrder() {
    this.$helper.toFusionPath(this, "defi", {
      name: "orders"
    });
  }
}
export default Actions;
